import Vue from 'vue'

let vm = {
  props: {
    showMask: Boolean
  }
}
Vue.component('LimitMask', vm)
export default vm


// WEBPACK FOOTER //
// ./src/common/js/mask.js